import React, { useState } from "react";
import Select from "react-select";

const options = [
  { value: "React", label: "React" },
  { value: "Vue", label: "Vue" },
  { value: "Angular", label: "Angular" },
  { value: "Java", label: "Java" },
];

const MultiSelectDropDown = () => {
  const [skills, setSkills] = useState([
    { value: "React", label: "React" },
    { value: "Vue", label: "Vue" },
  ]);
  const handleChange = (skills) => {
    console.log(skills);
    setSkills(skills || []);
  };

  return (
    <>
      <div className="container">
        <form>
          <Select
            options={options}
            onChange={handleChange}
            value={skills}
            isMulti
          />
        </form>
      </div>
    </>
  );
};

export default MultiSelectDropDown;
